// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiNewPlan {
    'available'?: string | null;
    'effectiveDate'?: string | null;
    'subscriberId'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiNewPlan>> = [
        {
            "name":     "available",
            "baseName": "available",
            "type":     "string"
        },
        {
            "name":     "effectiveDate",
            "baseName": "effectiveDate",
            "type":     "string"
        },
        {
            "name":     "subscriberId",
            "baseName": "subscriberId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiNewPlan.attributeTypeMap;
    }
}
